import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Section, Image, Link } from 'newComponents'
import { getHelp } from 'utils/thirdPartyUtils'
import logo from '../../../images/logos/LaunchDarkly_Icon_on_Dark_RGB.svg'
import Linkedin from '../../../images/_socials/LinkedIn.svg'
import Meetup from '../../../images/_socials/Meetup.svg'
import Twitter from '../../../images/_socials/Twitter.svg'
import Youtube from '../../../images/_socials/Youtube.svg'
import './styles.scss'

const FooterData = graphql`
  query {
    ...FooterQuery
  }
`

const NewFooter = () => {
  const data = useStaticQuery(FooterData)
  const { prismicSettings } = data
  const { data: footerLinks } = prismicSettings
  const { footer_main_text: mainText, footer_nav_link: navLinks } = footerLinks

  const navigationLinks = [
    { subheading: 'Support', children: [], prismicKey: 'Support' },
    { subheading: 'Why Us', children: [], prismicKey: 'Why LaunchDarkly' },
    { subheading: 'Learn', children: [], prismicKey: 'Learn' },
    { subheading: 'Company', children: [], prismicKey: 'Company' }
  ]

  // data formatting
  navLinks.forEach((link) => {
    const { link_subheading: subheading, link_text: text, link_url: to } = link
    navigationLinks.forEach((section) => {
      const { children, prismicKey } = section
      if (subheading === prismicKey) {
        children.push({ text: text?.text, link: to?.url })
      }
    })
  })

  const mainTextHtml = mainText?.html

  return (
    <Section className="new-footer">
      {/* /footer top */}
      <div className="new-footer-top">
        <div className="new-footer-main">
          <Image className="new-footer-logo" image={{ url: logo }} />
          {mainTextHtml && (
            <div
              className="new-footer-main-text"
              dangerouslySetInnerHTML={{
                __html: mainTextHtml
              }}
            />
          )}
        </div>
        {/* links sections */}
        <div className="new-footer-links-container">
          {navigationLinks.map((section) => {
            const { subheading, children } = section
            const heading = subheading.toUpperCase()
            return (
              <div className="new-footer-links-section" key={heading}>
                <span className="new-footer-links-heading">{heading}</span>
                <div className="new-footer-links-collection">
                  {children.map((link) => {
                    const { text, link: to } = link

                    return (
                      <Link className="new-footer-link" to={to} key={text}>
                        {text}
                      </Link>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
      {/* footer bottom */}
      <div className="new-footer-bottom">
        <span className="new-footer-copyright">©2021 Catamorphic Co.</span>
        <div className="new-footer-socials">
          <Link className="new-footer-socials-icon" to="https://twitter.com/launchdarkly">
            <Image image={Twitter} />
          </Link>
          <Link className="new-footer-socials-icon" to="https://www.linkedin.com/company/launchdarkly/">
            <Image image={Linkedin} />
          </Link>
          <Link className="new-footer-socials-icon" to="https://www.meetup.com/Test-in-Production/">
            <Image image={Meetup} />
          </Link>
          <Link
            className="new-footer-socials-icon"
            to="https://www.youtube.com/channel/UCyVjMONrMfeY9tsWZtUFtFw/videos"
          >
            <Image image={Youtube} />
          </Link>
        </div>
      </div>
    </Section>
  )
}

export default NewFooter
